/* ==========================================================================
   Cura — Press Ticker
   Duplicates logo set so CSS translateX(-50%) loops seamlessly.
   Editor-safe re-init on shopify:section:load.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.cptInit === 'true') return;
    root.dataset.cptInit = 'true';

    var track = root.querySelector('[data-cpt-track]');
    if (!track) return;

    var items = track.querySelectorAll('.cura-cpt__item');
    if (!items.length) return;

    // Duplicate every item for seamless looping.
    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cura-press-ticker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cura-press-ticker]');
    if (root) {
      root.dataset.cptInit = 'false';
      var track = root.querySelector('[data-cpt-track]');
      if (track) {
        track.querySelectorAll('[aria-hidden="true"]').forEach(function (el) { el.remove(); });
      }
      init(root);
    }
  });
})();